import { render, staticRenderFns } from "./UniBanner.vue?vue&type=template&id=0d3b879a&scoped=true&"
import script from "./UniBanner.vue?vue&type=script&lang=js&"
export * from "./UniBanner.vue?vue&type=script&lang=js&"
import style0 from "./UniBanner.vue?vue&type=style&index=0&id=0d3b879a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d3b879a",
  null
  
)

export default component.exports